import { render, staticRenderFns } from "./ResourceInformation.vue?vue&type=template&id=3a198732&"
import script from "./ResourceInformation.vue?vue&type=script&lang=js&"
export * from "./ResourceInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports